import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {ProjectService} from '@catcore/services';
import {Project} from '@catcore/types/api-v2';
import {ProjectDetailsService} from '@catdetails/services';
import {Observable} from 'rxjs/Rx';
import {isNullOrUndefined} from 'util';

@Injectable()
export class ProjectResolve implements Resolve<any> {
  constructor(private projectService: ProjectService,
              private projectDetailsService: ProjectDetailsService) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const projectId = route.paramMap.get('projectId');

    this.projectDetailsService.refresh(projectId);

    // return this.projectService
    //   .getProject(projectId)
    //   .map((projectInfo) => {
    //     this.projectDetailsService.loaded(projectId);
    //     this.projectService.setCurrentProject(projectInfo);
    //     return this.projectService.getCurrentProject();
    //   });

    this.projectService.loadAsCurrent(projectId);
    this.projectService
      .getCurrent()
      .subscribe((project: Project) => {
        if (!isNullOrUndefined(project)) {
          this.projectDetailsService.loaded(projectId);
          this.projectService.setCurrentProject(project);
        }
      });
    return projectId;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/resolve/project.resolve.ts